class SelectableDirective
  @$inject: []
  constructor: ()->
    class Selectable    
      require: '^selector'  
      scope:
        "selectable": "="
      link: (scope, element, attrs, selector)->

        selector.register(scope.selectable)
        dragging = false
        element.mousedown ()->
          dragging = false
        element.mousemove ()->
          dragging = true
        element.click ($event)->
          if dragging
            return
          selector.select scope.selectable          
        return @
        
    return new Selectable()
module.exports = SelectableDirective


// WEBPACK FOOTER //
// ./src/common/selector/selectable.coffee